import {
  Button,
  GroupTextField,
  GroupTextFieldRow,
  Icon,
} from "@elaniintc/goes-design-system";
import { months } from "../utils/utils";
interface ControlProps {
  currentDate: Date;
  handlePrevious: () => void;
  handleNext: () => void;
  backToDay: () => void;
}
const CalendarControls = ({
  currentDate,
  handlePrevious,
  handleNext,
  backToDay,
}: ControlProps) => {
  return (
    <div className="flex justify-between p-1 border-t border-b border-neutral-silent">
      <GroupTextField helperText="" label="">
        <GroupTextFieldRow className="h-8">
          <Button type="button" variant="quiet" size="xs">
            {months[currentDate.getMonth()]}
          </Button>
          <Button type="button" variant="quiet" size="xs">
            {currentDate.getFullYear()}
          </Button>
        </GroupTextFieldRow>
      </GroupTextField>

      <GroupTextField helperText="" label="" className="h-8">
        <GroupTextFieldRow className="h-8">
          <Button
            type="button"
            variant="quiet"
            size="icon"
            aria-label=""
            data-testid="control-previous"
            onClick={handlePrevious}
          >
            <Icon type="far" name="chevron-left" className="text-current" />
          </Button>
          <Button type="button" variant="quiet" size="xs" onClick={backToDay}>
            Hoy
          </Button>
          <Button
            type="button"
            variant="quiet"
            size="icon"
            aria-label=""
            data-testid="control-next"
            onClick={handleNext}
          >
            <Icon type="far" name="chevron-right" className="text-current" />
          </Button>
        </GroupTextFieldRow>
      </GroupTextField>
    </div>
  );
};

export default CalendarControls;
